import { fetchPhotosRT } from '../api/rt-mobile';

export const FETCH_PHOTOS_RT_PROCESS = () => dispatch => dispatch({ type: 'FETCH_PHOTOS_RT_PROCESS' });

export const FETCH_PHOTOS_RT_SUCCESS = data => dispatch => dispatch({ type: 'FETCH_PHOTOS_RT_SUCCESS', data });

export const FETCH_PHOTOS_RT_ERROR = () => dispatch => dispatch({ type: 'FETCH_PHOTOS_RT_ERROR' }); 

export const FETCH_PHOTOS_RT = () => (dispatch) => { 
    dispatch(FETCH_PHOTOS_RT_PROCESS());
    fetchPhotosRT()
        .then(data => dispatch(FETCH_PHOTOS_RT_SUCCESS(data)))
        .catch(() => dispatch(FETCH_PHOTOS_RT_ERROR()));
    return dispatch({ type: 'FETCH_PHOTOS_RT' });
};



// WEBPACK FOOTER //
// ./src/actions/photovideo.actions.js